import { Component } from '@angular/core';

@Component({
  selector: 'app-administration-panel-tabs',
  standalone: false,
  templateUrl: './administration-panel-tabs.component.html'
})
export class AdministrationPanelTabsComponent {

}
